import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_0e344b2e-d586-4fe9-9b9c-180c65724cc2/artifacts/im7zwgz1_182021234.png";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("berdhill_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function setAuthToken(token) {
  if (token) localStorage.setItem("berdhill_token", token);
  else localStorage.removeItem("berdhill_token");
}

export function fmtMoney(n, currency = "EUR") {
  return new Intl.NumberFormat("en-GB", { style: "currency", currency }).format(n);
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function addDaysISO(iso, days) {
  const d = new Date(iso);
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}
